import { ChangeDetectionStrategy, Component, input } from '@angular/core'

import { TooltipModule } from 'primeng/tooltip'

import { TOOLTIP_DEFAULT_DELAY } from '@flowx/designer/modules/core/dictionary/constants'

import { NotificationSummary, SummarySegmentType } from '../notifications-payload.model'

@Component({
  selector: 'flx-notification-summary',
  imports: [TooltipModule],
  templateUrl: './notification-summary.component.html',
  host: {
    class: 'block',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlxNotificationSummaryComponent {
  TOOLTIP_DEFAULT_DELAY = TOOLTIP_DEFAULT_DELAY
  SummarySegmentType = SummarySegmentType

  summary = input.required<NotificationSummary>()
}
